module.exports = __webpack_public_path__ + "img/船舶行业数字化转型场景图谱.d91e58d3.jpg";